// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__18P4_","pageNumber":"Paginator_pageNumber__xOsKi","selectedPage":"Paginator_selectedPage__3SIki"};